module.exports = __webpack_public_path__ + "img/dominican-republic.043da989.svg";